<template>
  <AccountPanel title="Dane firmy">
      <h5 class="card-title">{{user.company.fullname}}</h5>
      <p class="card-text">NIP: {{user.company.company.nip}}</p>
      <p class="card-text">{{user.company.street}}</p>
      <p class="card-text">{{user.company.postcode}} {{user.company.city}}</p>
      <p class="card-text">e-mail: {{user.company.email}}</p>
      <p class="card-text">tel: {{user.company.phone}}</p>
  </AccountPanel>
</template>

<script>

  import { mapState } from 'vuex';
  import AccountPanel from './AccountPanel.vue'

  export default {
    components: {AccountPanel},
    computed: {
      ...mapState({
        user: state => state.user.authorizedUser,
      }),
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/account/src/account/Company.vue